"use client";

import React from "react";
import { Github, Linkedin, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const services = ["Tailings Oversight & Management", "Geotechnical Project EOR", "Environmental Monitoring", "Water Management & Balance"];
const socials = [{
  name: "Twitter",
  icon: Twitter,
  href: "#"
}, {
  name: "Technical Journal",
  icon: Github,
  href: "#"
}, {
  name: "LinkedIn",
  icon: Linkedin,
  href: "#"
}];
const legalLinks = [{
  label: "Privacy Policy",
  href: "#"
}, {
  label: "Terms of Service",
  href: "#"
}, {
  label: "Compliance Statement",
  href: "#"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted/20 animate-pulse rounded-sm" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.length > 0 ? menuItems.map((item, i) => <li key={item.id} data-index={i}>
            
          </li>) : <li data-index={0}>
          <Link to="#" className="text-sm font-mono text-secondary hover:text-primary transition-colors duration-300">Geotechnical&nbsp;</Link>
        </li>}
    </ul>;
}
export default function Footer() {
  return <section data-section-id="163530" id="footer" className="dark bg-background text-foreground pt-16 pb-8 border-t border-border/10">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-16">
          {}
          <div className="flex flex-col items-start">
            <Link to="/HomePage" className="mb-6 inline-block">
              
            </Link>
            <p className="text-sm text-secondary leading-relaxed max-w-xs font-sans">ATG Engineering and Consulting. Global HQ: Sarasota Florida. International expertise in tailings, gypsum, and earthwork impoundment.</p>
          </div>

          {}
          <div>
            <h3 className="text-sm font-bold mb-6 text-foreground tracking-tighter uppercase font-sans">
              Core Services
            </h3>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="/ServicesPage" className="text-sm font-mono text-secondary hover:text-primary transition-colors duration-300">Operations&nbsp;</Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-sm font-bold mb-6 text-foreground tracking-tighter uppercase font-sans">
              Compliance & Standards
            </h3>
            <MenuProvider menu_id="46">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="text-sm font-bold mb-6 text-foreground tracking-tighter uppercase font-sans">
              Technical Network
            </h3>
            <div className="flex space-x-4">
              {socials.map((social, i) => <div key={i} data-index={i}>
                  <Link to={social.href} className="flex items-center justify-center size-10 rounded-sm bg-muted text-secondary hover:text-primary hover:bg-accent transition-all duration-300 border border-border/20" newTab>
                    <social.icon className="size-4" />
                    <span className="sr-only">{social.name}</span>
                  </Link>
                </div>)}
            </div>
          </div>
        </div>

        <Separator className="bg-border/20 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-secondary font-mono">© 2026 ATG Engineering and Consulting. All rights reserved.</p>
          <div className="flex flex-wrap items-center gap-3">
            {legalLinks.map((link, i) => <div key={i} data-index={i} className="flex items-center gap-3">
                <Link to={link.href} className="text-sm font-mono text-secondary hover:text-primary transition-colors duration-300">
                  {link.label}
                </Link>
                {i < legalLinks.length - 1 && <span className="w-1 h-1 rounded-full bg-primary/40" />}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}